<template>
  <div>
    <video
      id="background-video"
      autoplay
      loop
      muted
      poster="../assets/home/gif_menu.gif"
    >
      <source src="../assets/index/background.mp4" type="video/mp4" />
    </video>
    <div class="sections">
      <SectionImage
        text="OBRA"
        english_text="WORK"
        alt="Obra"
        leave_image="obra_leave.jpg"
        over_image="obra_over.gif"
        url="/works"
      />
      <SectionImage
        :text="page_name"
        english_text=""
        alt="Random"
        leave_image="random_leave.jpg"
        over_image="random_over.gif"
        rel="noopener noreferrer"
        target="_blank"
        :url="page_url"
      />
      <SectionImage
        text="ABOUT"
        english_text="CONTACT"
        alt="About"
        leave_image="about_leave.jpg"
        over_image="about_over.gif"
        url="/ABOUT"
      />
      <SectionImage
        text="ARCHIVO"
        english_text="ARCHIVE"
        alt="Direccion de arte"
        leave_image="arte_leave.jpg"
        over_image="arte_over.gif"
        url="/archive"
      />
      <SectionImage
        text="PHOTO PHONE"
        english_text=""
        alt="photo-phone"
        leave_image="contacto_leave.jpg"
        over_image="contacto_over.gif"
        url="/photophone"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SectionImage from "@/components/SectionImage.vue";
import axios from "axios";

export default {
  name: "Index",
  components: { SectionImage },
  data: function () {
    return {
      page_name: "DJ LADRA",
      page_url: "https://soundcloud.com/ladraaaaa",
    };
  },
  methods: {
    getData: async function () {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/extrapage/")
          .then((response) => {
            this.page_name = response.data[0].page_name;
            this.page_url = response.data[0].url;
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.sections {
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#background-video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
}

@media only screen and (max-width: 1100px) {
  .sections {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
  }
}
</style>
